<template>
  <el-dialog
    :model-value="modelValue"
    title="请扫码确认"
    width="400px"
    :align-center="true"
    @update:model-value="(v: boolean) => emit('update:modelValue', v)"
  >
    <div class="url-dialog-body">
      <!--
        /wechat/login may answer with a bare URL string instead of account
        info — the platform wants the operator to finish login through that
        link (the URL is usually a QR-code image wrapping a confirm short
        link). Render it inline; window.open here used to get eaten by
        popup blockers since it fired from an async .then().
      -->
      <el-image
        v-if="!imageFailed"
        class="url-dialog-image"
        :src="url"
        fit="contain"
        @error="imageFailed = true"
      />
      <div class="url-dialog-link">
        <a :href="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>
      </div>
    </div>
    <template #footer>
      <el-button @click="copyUrl">复制链接</el-button>
      <el-button type="primary" @click="emit('update:modelValue', false)">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { ElMessage } from "element-plus";

const props = defineProps<{
  modelValue: boolean;
  url: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const imageFailed = ref(false);
watch(() => props.url, () => { imageFailed.value = false; });

const copyUrl = async () => {
  try {
    await navigator.clipboard.writeText(props.url);
    ElMessage({ message: "已复制", type: "success" });
  } catch {
    ElMessage({ message: "复制失败，请手动复制", type: "error" });
  }
};
</script>

<style scoped>
.url-dialog-body {
  text-align: center;
}

.url-dialog-image {
  width: 200px;
  height: 200px;
}

.url-dialog-link {
  margin-top: 12px;
  word-break: break-all;
  font-size: 13px;
}
</style>
